import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiVisa, BaseApiTemplateService, Core2Config, Pagination, PagingResponseModel } from '../../shared';
import { MTOOptionLineContainerModel } from '../../../../../../models/aggregates/erp/mto/mto-option-line-container.model';

@Injectable({
  providedIn: 'root'
})
export class MTOOptionLineService extends BaseApiTemplateService<MTOOptionLineContainerModel> {

  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'option-lines';
  readonly endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'option-lines/' + Core2Config.PUBLIC_EP_SUFFIX;


  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'option-lines';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.FI_PREFIX + Core2Config.MADE_TO_ORDER_PREFIX + 'option-lines';
    this.httpClient = http;
  }

  getByCriteriaPublic(pagination: Pagination, visa: ApiVisa) {
    if (this.endpoint_path_public_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_public_url;
    }
    const UrlByCriteria = this.apiUrl + '/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<MTOOptionLineContainerModel>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }
}
